import { SERVERS_HAS_ERROR, SERVERS_IS_LOADING, SERVERS_FETCH_DATA_SUCCESS, SERVERS_CREATE_CACHE} from '../actions/servers'

   
export function serversHasError(state = null, action) {
    switch (action.type) {
        case SERVERS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function serversIsLoading(state = false, action) {
    switch (action.type) {
        case SERVERS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function servers(state = [], action) {
    switch (action.type) {
        case SERVERS_FETCH_DATA_SUCCESS:
            return action.servers;
          
        default:
            return state;
    }
}

export function serversCache(state = [], action) {
    switch (action.type) {
        case SERVERS_CREATE_CACHE:
            return action.serversCache;
          
        default:
            return state;
    }
}
